import React from 'react';
import PropTypes from 'prop-types';
import { Button, IconButton, Paper, Typography } from '@material-ui/core';
import { HighlightOff, Launch, PictureAsPdf } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    width: '100%',
    minWidth: '450px',
    maxWidth: '650px',
    height: '156px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2, 4),
    gap: theme.spacing(6),
    boxShadow:
      '2px 2px 1px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 2px rgba(0,0,0,0.14), 0px 1px 1px 0px rgba(0,0,0,0.12)',
  },
  pdfIcon: {
    fontSize: 60,
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1 1 auto',
    gap: theme.spacing(2),
  },
  truncatedText: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
    maxWidth: '300px',
  },
  viewButton: {
    whiteSpace: 'nowrap',
    padding: theme.spacing(1, 3),
    width: '100%',
  },
}));

const PdfCard = ({ onRemoveAttachment, onViewPdf, pdfAttachment }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.paper}>
      <PictureAsPdf color="primary" className={classes.pdfIcon} />

      <div className={classes.contentWrapper}>
        <Typography
          className={classes.truncatedText}
          title={pdfAttachment.titolo || 'Nome allegato.pdf'}
        >
          {pdfAttachment.titolo || 'Nome allegato.pdf'}
        </Typography>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<Launch />}
          onClick={() => onViewPdf(pdfAttachment.id)}
          disabled={!pdfAttachment?.id}
          className={classes.viewButton}
        >
          Visualizza pdf
        </Button>
      </div>

      <IconButton
        color="primary"
        size="small"
        aria-label="Rimuovi allegato"
        onClick={() => onRemoveAttachment(pdfAttachment.id)}
      >
        <HighlightOff />
      </IconButton>
    </Paper>
  );
};

PdfCard.propTypes = {
  pdfAttachment: PropTypes.object.isRequired,
  onRemoveAttachment: PropTypes.func.isRequired,
  onViewPdf: PropTypes.func.isRequired,
};

export default PdfCard;
